import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { fetchAuth } from '../auth/auth.thunk';

export enum TokenType {
  SharedDashboard = 'SHARED_DASHBOARD'
}

export interface IMetadataState {
  loading: boolean;
  tokenType?: TokenType;
  projectId?: string;
}

export interface IMetadataPayload {
  tokenType: TokenType;
  metadata: {
    projectId: string;
  };
}

export const initialState: IMetadataState = {
  loading: false,
  tokenType: undefined,
  projectId: undefined
};

const metadataSlice = createSlice({
  name: 'metadata',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuth.pending, (state) => {
        state.loading = true;
        state.tokenType = undefined;
      })
      .addCase(fetchAuth.fulfilled, (state: IMetadataState, action: PayloadAction<IMetadataPayload>) => {
        state.loading = false;
        state.tokenType = action.payload.tokenType;
        state.projectId = action.payload.metadata?.projectId;
      })
      .addCase(fetchAuth.rejected, () => initialState);
  }
});

export const MetadataReducer = metadataSlice.reducer;
export const actions = metadataSlice.actions;
export const caseReducers = metadataSlice.caseReducers;
